import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'translateDate'
})
export class TranslateDatePipe implements PipeTransform {
  transform(value: any, showTranslation: boolean, secondLanguage: string, format: string = 'longDate'): string {
    if (!value) {
      return '';
    }


if (value.year && value.month && value.day){
  const date = new Date(value.year, value.month, value.day);
 value = date;
}

    const datePipe = new DatePipe(this.getCurrentLocale(showTranslation, secondLanguage));
    return datePipe.transform(value, format) || '';
  }

  private getCurrentLocale(showTranslation: boolean, secondLanguage: string): string {
    if (!showTranslation || !secondLanguage) {
      return 'en-US';
    }

    const localeMap: { [key: string]: string } = {
      'czech': 'cs-CZ',
      'danish': 'da-DK',
      'dutch': 'nl-NL',
      'estonian': 'et-EE',
      'finnish': 'fi-FI',
      'french': 'fr-FR',
      'german': 'de-DE',
      'greek': 'el-GR',
      'hungarian': 'hu-HU',
      'italian': 'it-IT',
      'latvian': 'lv-LV',
      'lithuanian': 'lt-LT',
      'luxembourgish': 'fr-LU',
      'norwegian': 'nb-NO',
      'polish': 'pl-PL',
      'portuguese': 'pt-PT',
      'slovak': 'sk-SK',
      'slovenian': 'sl-SI',
      'spanish': 'es-ES',
      'swedish': 'sv-SE'
    };

    return localeMap[secondLanguage.toLowerCase()] || 'en-US';
  }
} 


// WEBPACK FOOTER //
// ./src/app/shared/pipes/translate-date.pipe.ts